import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';
import axios from '../../utils/axios';
import { primaryRestGateway } from '../../utils/apiEndpointUtility';

import {
	getCustomerDetails,
	getCustomerDetailsCompleted,
	getCustomerDetailsFailed,
	postBrowserDetails,
	postBrowserDetailsCompleted,
	postBrowserDetailsFailed,
	postCustomerDetails,
	postCustomerDetailsCompleted,
	postCustomerDetailsFailed
} from './customerDetailsSlice';

export const getCustomerDetailsEpic = (action$) =>
	action$.pipe(
		ofType(getCustomerDetails),
		mergeMap(async (action) => {
			const paylinkId = action.payload;
			const response = await axios.get(`${primaryRestGateway()}/${paylinkId}`);
			return response.data;
		}),
		switchMap((response) => [getCustomerDetailsCompleted(response)]),
		catchError((error, source) =>
			merge(of(getCustomerDetailsFailed(error.message)), source)
		)
	);

export const postBrowserDetailsEpic = (action$) =>
	action$.pipe(
		ofType(postBrowserDetails),
		mergeMap(async (action) => {
			const payload = action.payload;
			const { paylinkId, ...payloadNoPaylinkId } = payload;

			const response = await axios.post(
				`${primaryRestGateway()}/${payload.paylinkId}`,
				payloadNoPaylinkId
			);
			return response.data;
		}),
		switchMap((response) => [postBrowserDetailsCompleted(response)]),
		catchError((error, source) =>
			merge(of(postBrowserDetailsFailed(error.message)), source)
		)
	);

export const postCustomerDetailsEpic = (action$) =>
	action$.pipe(
		ofType(postCustomerDetails),
		mergeMap(async (action) => {
			const payload = action.payload;
			const { paylinkId, ...payloadNoPaylinkId } = payload;

			const response = await axios.put(
				`${primaryRestGateway()}/${payload.paylinkId}`,
				payloadNoPaylinkId
			);
			return response.data;
		}),
		switchMap((response) => [postCustomerDetailsCompleted(response)]),
		catchError((error, source) =>
			merge(of(postCustomerDetailsFailed(error.message)), source)
		)
	);

export default [
	getCustomerDetailsEpic,
	postBrowserDetailsEpic,
	postCustomerDetailsEpic
];
